import ExamRoomFooter from './ExamRoomFooter';

export default ExamRoomFooter;
